<div class="flex flex-col h-full">
  
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h2 class="text-xl font-semibold text-gray-900 dark:text-white">
        Historia Sesji Batch
      </h2>
      <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
        Wszystkie wysyłki batch z pełną historią faktur
      </p>
    </div>
    <div class="flex gap-3 items-center flex-wrap">
      <!-- Email Search -->
      <mat-form-field appearance="outline" class="w-64">
        <mat-label>Szukaj po emailu</mat-label>
        <input 
          matInput 
          [(ngModel)]="emailSearch"
          (ngModelChange)="onSearchChange()"
          placeholder="email@example.com">
        <button 
          *ngIf="emailSearch"
          matSuffix 
          mat-icon-button 
          (click)="clearSearch()"
          matTooltip="Wyczyść">
          <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
        </button>
        <mat-icon *ngIf="!emailSearch" matSuffix [svgIcon]="'tabler_outline:search'"></mat-icon>
      </mat-form-field>

      <!-- Status Filter -->
      <mat-form-field appearance="outline" class="w-48">
        <mat-label>Filtruj po statusie</mat-label>
        <mat-select [(ngModel)]="statusFilter" (selectionChange)="onStatusFilterChange()">
          <mat-option value="">Wszystkie</mat-option>
          <mat-option value="pending">Oczekuje</mat-option>
          <mat-option value="checking">Sprawdzanie</mat-option>
          <mat-option value="processing">Przetwarzanie</mat-option>
          <mat-option value="completed">Zakończona</mat-option>
          <mat-option value="timeout">Timeout</mat-option>
          <mat-option value="error">Błąd</mat-option>
        </mat-select>
      </mat-form-field>

      <button 
        mat-flat-button 
        color="primary"
        (click)="refresh()"
        [disabled]="isLoading">
        <mat-icon [svgIcon]="'tabler_outline:refresh'"></mat-icon>
        Odśwież
      </button>
    </div>
  </div>

  <!-- Stats Cards -->
  <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
    <div class="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-3">
      <div class="text-sm text-yellow-800 dark:text-yellow-300">Oczekuje</div>
      <div class="text-2xl font-bold text-yellow-900 dark:text-yellow-200">{{ stats.pending }}</div>
    </div>
    
    <div class="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-3">
      <div class="text-sm text-blue-800 dark:text-blue-300">Sprawdzanie</div>
      <div class="text-2xl font-bold text-blue-900 dark:text-blue-200">{{ stats.checking }}</div>
    </div>

    <div class="bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-lg p-3">
      <div class="text-sm text-purple-800 dark:text-purple-300">Przetwarzanie</div>
      <div class="text-2xl font-bold text-purple-900 dark:text-purple-200">{{ stats.processing }}</div>
    </div>
    
    <div class="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-3">
      <div class="text-sm text-green-800 dark:text-green-300">Zakończona</div>
      <div class="text-2xl font-bold text-green-900 dark:text-green-200">{{ stats.completed }}</div>
    </div>

    <div class="bg-gray-50 dark:bg-gray-900/20 border border-gray-200 dark:border-gray-800 rounded-lg p-3">
      <div class="text-sm text-gray-800 dark:text-gray-300">Timeout</div>
      <div class="text-2xl font-bold text-gray-900 dark:text-gray-200">{{ stats.timeout }}</div>
    </div>

    <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3">
      <div class="text-sm text-red-800 dark:text-red-300">Błąd</div>
      <div class="text-2xl font-bold text-red-900 dark:text-red-200">{{ stats.error }}</div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-12">
    <mat-spinner [diameter]="60"></mat-spinner>
    <p class="text-gray-600 dark:text-gray-400 mt-4">Ładowanie sesji batch...</p>
  </div>

  <!-- Table -->
  <div *ngIf="!isLoading" class="flex-1 overflow-hidden bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
    <div class="overflow-auto h-full">
      <table mat-table [dataSource]="dataSource" class="w-full">
        
        <!-- Session Ref Column -->
        <ng-container matColumnDef="sessionRef">
          <th mat-header-cell *matHeaderCellDef>Session Ref</th>
          <td mat-cell *matCellDef="let session">
            <div class="text-sm font-mono text-gray-900 dark:text-white">
              {{ session.sessionRef }}
            </div>
          </td>
        </ng-container>

        <!-- User Column -->
        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef>Użytkownik</th>
          <td mat-cell *matCellDef="let session">
            <div *ngIf="session.userId" class="text-sm">
              <button 
                class="text-blue-600 dark:text-blue-400 hover:underline font-medium cursor-pointer bg-transparent border-none p-0 text-left"
                (click)="searchByEmail(session.userId.emailAddress, $event)"
                [matTooltip]="'Szukaj sesji dla: ' + session.userId.emailAddress"
              >
                {{ session.userId.emailAddress }}
              </button>
              <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                {{ session.userId.company?.name || (session.userId.firstName + ' ' + session.userId.lastName) }}
              </div>
            </div>
            <span *ngIf="!session.userId" class="text-gray-400">-</span>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let session">
            <div [class]="'inline-flex items-center px-3 py-1.5 rounded-full text-xs font-semibold ' + getStatusColor(session.status)">
              <mat-icon 
                [svgIcon]="getStatusIcon(session.status)" 
                [class]="'mr-1.5 !w-4 !h-4 ' + getStatusIconColor(session.status)">
              </mat-icon>
              {{ getStatusLabel(session.status) }}
            </div>
          </td>
        </ng-container>

        <!-- Invoices Column -->
        <ng-container matColumnDef="invoices">
          <th mat-header-cell *matHeaderCellDef class="text-center">Faktury</th>
          <td mat-cell *matCellDef="let session" class="text-center">
            <div class="flex items-center justify-center gap-2 flex-wrap">
              <div class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300">
                {{ session.invoiceCount }}
              </div>
              <ng-container *ngIf="session.status === 'completed'">
                <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 font-medium text-xs">
                  ✓ {{ session.successfulInvoices }}
                </span>
                <span *ngIf="session.failedInvoices > 0" class="inline-flex items-center px-2 py-0.5 rounded-full bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 font-medium text-xs">
                  ✗ {{ session.failedInvoices }}
                </span>
              </ng-container>
            </div>
          </td>
        </ng-container>

        <!-- Created At Column -->
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>Utworzona</th>
          <td mat-cell *matCellDef="let session">
            <div class="text-sm text-gray-700 dark:text-gray-300">
              {{ session.createdAt | date:'dd.MM.yyyy' }}
            </div>
            <div class="text-xs text-gray-500 dark:text-gray-400">
              {{ session.createdAt | date:'HH:mm:ss' }}
            </div>
          </td>
        </ng-container>

        <!-- Processing Time Column -->
        <ng-container matColumnDef="processingTime">
          <th mat-header-cell *matHeaderCellDef>Czas</th>
          <td mat-cell *matCellDef="let session">
            <div class="text-sm text-gray-700 dark:text-gray-300">
              {{ formatProcessingTime(session.totalProcessingTime) }}
            </div>
            <div class="text-xs text-gray-500 dark:text-gray-400" *ngIf="session.checkAttempts > 0">
              {{ session.checkAttempts }} prób
            </div>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="w-32">Akcje</th>
          <td mat-cell *matCellDef="let session">
            <div class="flex gap-1">
              <button 
                mat-icon-button 
                [matTooltip]="'Zobacz szczegóły'"
                color="primary"
                (click)="openDetails(session)">
                <mat-icon [svgIcon]="'tabler_outline:eye'"></mat-icon>
              </button>

              <button 
                *ngIf="canRetry(session)"
                mat-icon-button 
                [matTooltip]="'Retry sesji'"
                color="warn"
                (click)="retrySession(session, $event)">
                <mat-icon [svgIcon]="'tabler_outline:refresh'"></mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr 
          mat-row 
          *matRowDef="let row; columns: displayedColumns;"
          class="hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
          >
        </tr>

        <!-- Empty State -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center py-12" [attr.colspan]="displayedColumns.length">
            <div class="flex flex-col items-center">
              <mat-icon 
                class="text-gray-400 dark:text-gray-600 mb-4"
                [svgIcon]="'tabler_outline:inbox'"
                style="width: 64px; height: 64px; font-size: 64px;">
              </mat-icon>
              <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-2">
                Brak sesji batch
              </h3>
              <p class="text-gray-600 dark:text-gray-400">
                {{ emailSearch ? 'Nie znaleziono sesji dla: ' + emailSearch : 'Nie znaleziono żadnych sesji batch' }}
              </p>
              <button 
                *ngIf="emailSearch"
                mat-stroked-button 
                color="primary"
                class="mt-4"
                (click)="clearSearch()">
                Wyczyść wyszukiwanie
              </button>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <!-- Paginator -->
    <mat-paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPageChange($event)"
      showFirstLastButtons
      class="border-t border-gray-200 dark:border-gray-700">
    </mat-paginator>
  </div>
</div>

